import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User } from "lucide-react";
import { toast } from "sonner";
import { SITE_ASSETS } from "../../mock";
import { login as apiLogin, setToken } from "../../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await apiLogin(u, p);
      setToken(res.token);
      toast.success("Welcome back, Admin.");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1F1B17] grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={SITE_ASSETS.hero.aerial} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#1F1B17]/60"></div>
        <div className="absolute bottom-12 left-12 right-12 text-[#F5EFE6]">
          <div className="text-[11px] tracking-[0.5em] text-[#B8893C] uppercase mb-4">Tamra Admin Console</div>
          <div className="font-display text-4xl tracking-[0.05em] leading-tight">Steward of every Tamra address.</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md bg-[#F5EFE6] p-10">
          <div className="flex items-center gap-3 mb-10">
            <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center overflow-hidden ring-1 ring-[#B8893C]/40">
              <img src={SITE_ASSETS.logo} alt="Tamra" className="w-10 h-10 object-contain" />
            </div>
            <div>
              <div className="font-display text-xl tracking-[0.28em] text-[#5C2018]">TAMRA</div>
              <div className="text-[10px] tracking-[0.42em] text-[#B8893C] mt-1">ADMIN</div>
            </div>
          </div>

          <div className="section-eyebrow mb-3">Sign In</div>
          <h1 className="font-display text-3xl tracking-[0.05em] text-[#1F1B17] mb-8">Welcome Back.</h1>

          <label className="block mb-5">
            <span className="text-[10px] tracking-[0.4em] uppercase text-[#B8893C]">Username</span>
            <div className="flex items-center gap-3 mt-2 border-b border-[#EBE0CE] focus-within:border-[#B8893C] py-2">
              <User size={16} className="text-[#9C7A3F]" />
              <input value={u} onChange={(e) => setU(e.target.value)} className="w-full bg-transparent outline-none text-[#1F1B17]" placeholder="admin" />
            </div>
          </label>
          <label className="block mb-8">
            <span className="text-[10px] tracking-[0.4em] uppercase text-[#B8893C]">Password</span>
            <div className="flex items-center gap-3 mt-2 border-b border-[#EBE0CE] focus-within:border-[#B8893C] py-2">
              <Lock size={16} className="text-[#9C7A3F]" />
              <input type="password" value={p} onChange={(e) => setP(e.target.value)} className="w-full bg-transparent outline-none text-[#1F1B17]" placeholder="••••••••" />
            </div>
          </label>
          <button disabled={loading} className="btn-primary w-full justify-center">
            {loading ? "Signing in..." : "Sign In"}
          </button>
          <div className="text-[11px] text-[#9C7A3F] mt-6">Demo credentials: admin / #Admin@2026</div>
        </form>
      </div>
    </div>
  );
}
